import React from "react";
import Navbar from "../components/Navbar";
import { FaUsers, FaUser } from "react-icons/fa6";
import { BsPersonFillCheck } from "react-icons/bs";
import Table from "../components/Table";
import useAuth from "../hooks/useAuth";
const Dashboard = () => {
  const { users } = JSON.parse(window.localStorage.getItem("admin"));
  const { logout } = useAuth();

  return (
    <div className="main-container">
      <Navbar logout={logout} />
      <div className="dashboard-container">
        <div className="dashboard-left">
          <div className="users-summary-info-container">
            <div className="users-summary-container">
              <FaUsers className="users-summary-icon" />
              <h3 className="users-summary-title">Tot. Users</h3>
              <span className="users-summary-data">{users.length}</span>
            </div>
            <div className="users-summary-container">
              <BsPersonFillCheck className="users-summary-icon" />
              <h3 className="users-summary-title">Premium us.</h3>
              <span className="users-summary-data">4</span>
            </div>
            <div className="users-summary-container">
              <FaUser className="users-summary-icon" />
              <h3 className="users-summary-title">Basic us.</h3>
              <span className="users-summary-data">4</span>
            </div>
          </div>
          <div className="users-table-container">
            <h1 className="heading-text">Users list</h1>
            <Table data={users} />
          </div>
        </div>
        <div className="dashboard-right">right</div>
      </div>
    </div>
  );
};

export default Dashboard;
